import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WhatsappLinkService } from './whatsapp-link.service';

/** Runs link/confirm once when Amplify authenticator reaches the signed-in slot. */
@Component({
  selector: 'app-whatsapp-link-handler',
  template: `
    <mat-card class="card">
      <mat-card-content>
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'WHATSAPP.LINKING' | translate }}</p>
      </mat-card-content>
    </mat-card>
  `,
  styles: [
    `
      mat-card-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        padding: 2rem;
      }
    `,
  ],
})
export class WhatsappLinkHandlerComponent implements OnInit {
  /** From ?session= on the connect URL (same value sent in link/confirm body). */
  @Input() linkSessionId = '';

  @Output() completed = new EventEmitter<void>();
  @Output() failed = new EventEmitter<string>();

  constructor(private whatsappLinkService: WhatsappLinkService) {}

  ngOnInit(): void {
    void this.run();
  }

  private async run(): Promise<void> {
    try {
      await this.whatsappLinkService.completePendingLink(this.linkSessionId);
      this.completed.emit();
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Link failed';
      this.failed.emit(message);
    }
  }
}
